import styled from 'styled-components';

export const LoginErrorContainer = styled.div`
  background-color: #dd3b52;
  display: flex;
  padding: 1.6rem 1.6rem;
  border-radius: 12px;
  align-items: center;
  gap: 1.6rem;
  margin-top: 3.2rem;
`;

export const Title = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 500;
  margin-bottom: 0.8rem;
`;

export const Message = styled.p`
  font-size: 1.4rem;
  line-height: 1.6rem;
  font-weight: 400;
  order: 1;
  text-align: justify;
  flex-grow: 0;

  > strong {
    font-size: 1.4rem;
    line-height: 1.6rem;
    font-weight: 600;
  }
`;
